import React from 'react';
import { Button } from '../ui/Button';
import { ArrowRight } from 'lucide-react';
import { DemoDialog } from '../DemoDialog';
import { ContactDialog } from '../ContactDialog';
export function FinalCTA() {
  return <section className="w-full py-20 md:py-28 relative" style={{
    backgroundColor: '#09090B',
    backgroundImage: 'radial-gradient(circle, rgba(255,255,255,0.03) 1px, transparent 1px)',
    backgroundSize: '24px 24px'
  }} data-id="element-381">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative" data-id="element-382">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight font-heading" data-id="element-383">
          MeetOS se construit pour des événements comme les vôtres.
        </h2>
        <p className="text-lg text-white/50 mt-6 max-w-2xl mx-auto leading-relaxed" data-id="element-384">
          Parlez-nous de votre calendrier événementiel. Nous vous montrons la
          plateforme en environnement réel et cartographions chacun de vos
          besoins avec les fonctionnalités disponibles.
        </p>
        <div className="mt-10 flex flex-wrap justify-center gap-4" data-id="element-385">
          <DemoDialog data-id="element-386">
            <Button size="lg" className="bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-600 hover:to-blue-600 text-white border-0 px-8 shadow-[0_0_30px_rgba(6,182,212,0.3)]" data-id="element-387">
              Demander une démo
              <ArrowRight className="ml-2 h-4 w-4" data-id="element-388" />
            </Button>
          </DemoDialog>
          <ContactDialog data-id="element-389">
            <Button variant="default" size="lg" className="bg-cyan-500/10 border border-cyan-500/50 text-cyan-400 hover:bg-cyan-500/20 hover:text-cyan-300 px-8" data-id="element-390">
              Nous contacter
            </Button>
          </ContactDialog>
        </div>
      </div>
    </section>;
}